// start:ng42.barrel
import './staff-roles-external.component';
import './staff-roles-internal-roles.component';
import './staff-roles-internal-users.component';
import './staff-roles-internal.component';
import './staff-roles.component';
// end:ng42.barrel

